import React from 'react'
import {Select, MenuItem} from '@material-ui/core'
import useStyles from './TFontFamily.styles'

const TFontFamily = props => {
  const classes = useStyles()

  return (
    <Select
      className={classes.root}
      defaultValue={props.value}
      value={props.value}
      onChange={props.onChange}
    >
      {FontFamilyOptions.map((v, i) => (
        <MenuItem key={i} className={classes.option} value={v}>
          {v}
        </MenuItem>
      ))}
    </Select>
  )
}

export default TFontFamily

const FontFamilyOptions = [
  'Arial',
  'Georgia',
  'Impact',
  'Roboto',
  'Tahoma',
  'Times New Roman',
  'Verdana',
]
